"use client";

import { IconLoader, IconSend, IconCheck } from "@/lib/tabler-icons";
import { cn } from "@/lib/utils";

interface FormSubmitButtonProps {
	isLoading?: boolean;
	isSuccess?: boolean;
	isError?: boolean;
	disabled?: boolean;
	children?: React.ReactNode;
	className?: string;
}

export const FormSubmitButton = ({
	isLoading = false,
	isSuccess = false,
	isError = false,
	disabled = false,
	children = "Enviar mensaje",
	className,
}: FormSubmitButtonProps) => {
	const getButtonContent = () => {
		if (isLoading) {
			return (
				<>
					<IconLoader className="animate-spin h-5 w-5" />
					Enviando...
				</>
			);
		}
		if (isSuccess) {
			return (
				<>
					<IconCheck className="h-5 w-5" />
					¡Enviado!
				</>
			);
		}
		return (
			<>
				<IconSend className="h-5 w-5" />
				{children}
			</>
		);
	};

	const getButtonStyles = () => {
		if (isSuccess) {
			return "bg-ink text-cream opacity-90 cursor-default";
		}
		if (isError) {
			return "bg-terracotta text-cream hover:bg-terracotta/90";
		}
		if (disabled || isLoading) {
			return "bg-ink/30 text-cream/50 cursor-not-allowed";
		}
		return "bg-ink text-cream hover:bg-ink/90";
	};

	return (
		<button
			type="submit"
			disabled={disabled || isLoading}
			className={cn(
				"font-body inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full font-medium transition-all duration-200",
				"focus:outline-none focus:ring-2 focus:ring-ink focus:ring-offset-2",
				getButtonStyles(),
				className
			)}
		>
			{getButtonContent()}
		</button>
	);
};
